import { mapGetters } from 'vuex'
import moment from 'moment'

const hraMixin = {
  data () {
    return {
      hraDate: ''
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    }),
    healthParameters: function () {
      if (this.customer && this.customer.details && this.customer.details.health_parameters) {
        const healthParams = this.customer.details.health_parameters
        this.hraDate = healthParams.date ? moment(healthParams.date).format('Do MMM YYYY') : 'NA'
        const Hra = []
        Hra.push(this.addDietAssessment(healthParams))
        Hra.push(this.addPastMedicalHistory(healthParams))
        Hra.push(this.addLifestyleHistory(healthParams))
        Hra.push(this.addFamilyHistory(this.customer.details.family_history))
        return Hra
      }
      return []
    }
  },
  methods: {
    addDietAssessment: function (healthParams) {
      let values = {
        0: {text: 'High', color: 'text-red'},
        1: {text: 'Medium', color: 'text-orange'},
        2: {text: 'Low', color: 'text-green'}
      }
      let noData = {text: 'NA', color: ''}
      return {
        type: 'DIET ASSESSMENT',
        updatedOn: '',
        items: [
          {name: 'Whole Grains', ...values[healthParams.whole_grains] || noData},
          {name: 'Fruits and vegetables', ...values[healthParams.fruits_and_vegetables] || noData},
          {name: 'fried fruits & refined carboydrates', ...values[healthParams.fried_foods_and_refined_carbohydrates] || noData}
        ]
      }
    },
    addPastMedicalHistory: function (healthParams) {
      let values = {
        true: {text: 'Yes', color: 'text-red'},
        false: {text: 'No', color: 'text-green'}
      }
      let noData = {text: 'NA', color: ''}
      return {
        type: 'PAST MEDICAL HISTORY',
        items: [
          {name: 'Diabetes', ...values[healthParams.diabetic_treatment] || noData},
          {name: 'Cancer', ...values[healthParams.cancer] || noData},
          {name: 'BP', ...values[healthParams.hypertensive_treatment] || noData},
          {name: 'Heart Condition', ...values[healthParams.cvd_treatment] || noData}
        ]
      }
    },
    addLifestyleHistory: function (healthParams) {
      let values = {
        true: {text: 'Yes', color: 'text-red'},
        false: {text: 'No', color: 'text-green'}
      }
      return {
        type: 'LIFESTYLE HISTORY',
        items: [
          {name: 'Low Self Esteem', ...values[healthParams.low_self_esteem]},
          {name: 'Fatigue', ...values[healthParams.fatigue]},
          {name: 'Body Aches', ...values[healthParams.body_aches]},
          {name: 'Anxiety', ...values[healthParams.anxiety]},
          {name: 'Nervous Breakdown', ...values[healthParams.nervous_breakdown]},
          {name: 'Stress Eating', ...values[healthParams.stress_eating]}
        ]
      }
    },
    addFamilyHistory: function (healthParams) {
      let values = {
        true: {text: 'Yes', color: 'text-red'},
        false: {text: 'No', color: 'text-green'}
      }
      let fathersHistory = healthParams.fathers_history || ['None']
      let mothersHistory = healthParams.mothers_history || ['None']
      return {
        type: 'FAMILY HISTORY',
        items: [
          {name: 'Diabetes', father: values[fathersHistory.includes('Diabeties')], mother: values[mothersHistory.includes('Diabeties')]},
          {name: 'BP', father: values[fathersHistory.includes('Hypertension')], mother: values[mothersHistory.includes('Hypertension')]},
          {name: 'Heart Condition', father: values[fathersHistory.includes('Heart Condition')], mother: values[mothersHistory.includes('Heart Condition')]},
          {name: 'Cancer', father: values[fathersHistory.includes('Cancer')], mother: values[mothersHistory.includes('Diabetes')]}
        ]
      }
    }
  }
}

export default hraMixin



// WEBPACK FOOTER //
// ./src/components/mixins/hra_mixin.js